var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewexcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.37,
    height: 16.533,
    viewBox: "0 0 18.37 16.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(-1036.521 -994.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-microsoft-excel-2019",
    transform: "translate(1032.521 988.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M20.889,6H14.8a.8.8,0,0,0-.8.8v3.334h6.889Z",
    transform: "translate(-5.407 0)",
    fill: "#169154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M14,33.054v3.308a.8.8,0,0,0,.8.8h6.088V33.054Z",
    transform: "translate(-5.407 -14.629)",
    fill: "#18482a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M14,15h6.889v4.134H14Z",
    transform: "translate(-5.407 -4.868)",
    fill: "#0c8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M14,24h6.889v4.156H14Z",
    transform: "translate(-5.407 -9.736)",
    fill: "#17472a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(15.481 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M35.088,6H29v4.135h6.889V6.8A.8.8,0,0,0,35.088,6Z",
    transform: "translate(-29 -6)",
    fill: "#29c27f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M29,33.054v4.108h6.088a.8.8,0,0,0,.8-.8V33.054H29Z",
    transform: "translate(-29 -20.629)",
    fill: "#27663f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M29,15h6.889v4.134H29Z",
    transform: "translate(-29 -10.868)",
    fill: "#19ac65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M29,24h6.889v4.156H29Z",
    transform: "translate(-29 -15.736)",
    fill: "#129652"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M12.413,23.185H4.772A.772.772,0,0,1,4,22.413V14.772A.772.772,0,0,1,4.772,14h7.641a.772.772,0,0,1,.772.772v7.641A.772.772,0,0,1,12.413,23.185Z",
    transform: "translate(0 -4.326)",
    fill: "#0c7238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M9.655,19h1.1l.889,1.724L12.58,19H13.6l-1.41,2.3,1.443,2.3h-1.08l-.969-1.8-.965,1.8h-1.1l1.466-2.3Z",
    transform: "translate(-2.988 -7.03)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewexcel);
export default __webpack_public_path__ + "static/media/Newexcel.d2324cb1b63bd092fb61ac420573a128.svg";
export { ForwardRef as ReactComponent };